import type { View } from "./trip.ts";

const BASE = import.meta.env.VITE_API_URL ?? "/api";

export type Fetched = { kind: "ok"; view: View } | { kind: "ended" } | { kind: "not_found" } | { kind: "error" };

/** `GET /public/trips/{token}`: 410 once the share stopped or expired, 404 for an unknown token. */
export async function fetchTrip(token: string, signal?: AbortSignal): Promise<Fetched> {
  try {
    const res = await fetch(`${BASE}/public/trips/${encodeURIComponent(token)}`, { signal, headers: { accept: "application/json" } });
    if (res.status === 410) return { kind: "ended" };
    if (res.status === 404) return { kind: "not_found" };
    if (!res.ok) return { kind: "error" };
    return { kind: "ok", view: (await res.json()) as View };
  } catch (e) {
    if ((e as Error).name === "AbortError") throw e;
    return { kind: "error" };
  }
}
